import Http from "./base-http";

class Benefit extends Http {
  deleteBenefit(id) {
    return this.destroy(id);
  }
  addBenefit(variables) {
    return this.create(variables);
  }
}
const benefitObj = new Benefit({
  modelUrlPrefix : "benefit"
});

export default benefitObj;